module.exports = __webpack_public_path__ + "img/timeline_miscevent-24.7311adb2.jpg";